/*
 * Reef hero — moves the actinic "spotlight" with the pointer.
 * Sets CSS custom properties --x / --y (percentages) that reef-brand.css
 * reads to position the radial mask on the glow layer.
 * Skips entirely on touch / no-hover / reduced-motion (a static centered
 * glow is shown by CSS in that case).
 */
(function () {
  function init() {
    var heroes = document.querySelectorAll('[data-reef-hero]');
    if (!heroes.length) return;

    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (prefersReduced || !canHover) return;

    heroes.forEach(function (hero) {
      var rafId = null;
      var px = 50;
      var py = 50;

      hero.classList.add('reef-hero--interactive');

      function apply() {
        hero.style.setProperty('--x', px + '%');
        hero.style.setProperty('--y', py + '%');
        rafId = null;
      }

      function queue() {
        if (rafId === null) rafId = window.requestAnimationFrame(apply);
      }

      hero.addEventListener('pointermove', function (event) {
        var rect = hero.getBoundingClientRect();
        px = ((event.clientX - rect.left) / rect.width) * 100;
        py = ((event.clientY - rect.top) / rect.height) * 100;
        hero.classList.remove('reef-hero--resting');
        queue();
      });

      hero.addEventListener('pointerleave', function () {
        // drop the JS override so the spotlight eases back to the CSS
        // resting position (over the coral wall), via the resting transition.
        hero.classList.add('reef-hero--resting');
        if (rafId !== null) {
          window.cancelAnimationFrame(rafId);
          rafId = null;
        }
        hero.style.removeProperty('--x');
        hero.style.removeProperty('--y');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
